import z from "zod";
import "./App.css";
import logo from "./assets/heroi.webp";
import { TelegramButton } from "./telegram";

type LPConfig = {
  header: string;
  title: string;
  title2: string;
  subtitle: string;
  ctaButton: string;
  ctaSubtitle: string;
  footer: string;
};

const CONFIG: Record<string, LPConfig> = {
  "ph-geral": {
    header: "🎯 MELHORES PROMOÇÕES E CUPONS DIRETO NO SEU CELULAR",
    title: "🚨 GRUPO VIP 🚨",
    title2: "100% GRATUITO",
    subtitle: "OFERTAS com 50% 60% 70% OFF 🦸🏻‍♂️",
    ctaButton: "GRUPO DO WHATSAPP",
    ctaSubtitle: "⚡️ JÁ SOMOS +180 MIL MEMBROS ⚡️",
    footer: "Direitos Reservados",
  },
};

const ZVariant = z
  .string()
  .nullable()
  .optional()
  .transform((value) => {
    const v = value?.toLowerCase();

    if (v === "telegram") return "telegram";
    if (v === "whatsapp") return "whatsapp";
    if (v === "all") return "all";

    return "all";
  });

export type Variant = z.infer<typeof ZVariant>;

function App() {
  const variant = ZVariant.parse(
    new URLSearchParams(window.location.search).get("variant"),
  );

  const config = CONFIG["ph-geral"];

  const showWhatsapp = variant === "whatsapp" || variant === "all";
  const showTelegram = variant === "telegram" || variant === "all";

  return (
    <div className="container">
      <header className="header">
        <h1>{config.header}</h1>
      </header>

      <main className="main-content">
        <div className="vip-group-title">
          <p>{config.title}</p>
          <p>{config.title2}</p>
        </div>

        <div className="discount-text">{config.subtitle}</div>

        <div className="cta-container">
          <div className="icon-container">
            <img src={logo} alt="Shopping Bag" className="shopping-bag-icon" />
          </div>

          {showWhatsapp && (
            <a
              href="https://sndflw.com/i/IMjf4nRkByULuLeLWUzQ"
              className="cta-button animated-fast animated tada"
            >
              {config.ctaButton}
            </a>
          )}

          {showTelegram && (
            <TelegramButton
              href="https://t.me/heroidapromo"
              ariaLabel="Telegram button"
              className="animated-fast animated tada"
            >
              CANAL DO TELEGRAM
            </TelegramButton>
          )}
        </div>
      </main>

      <footer className="footer">{config.footer}</footer>
    </div>
  );
}

export default App;
